import { isDefined, isNumber } from './../utils';
import { HEIGHT, WIDTH, X, Y } from '../constants';
import { Scale } from './Scale';
import { Translation } from './Translation';
/**
 * Mixin that provides automatic sizing and positioning capabilities for visual elements.
 * Can be mixed into classes to add automatic scaling and translation functionality.
 */
export const AutoSizeableMixin = {
    /**
     * @hidden
     * Sets the scale transformation based on the difference between original and target dimensions.
     */
    _setScale: function () {
        const options = this.options;
        const originWidth = this._originWidth;
        const originHeight = this._originHeight;
        let scaleX = options.width / originWidth;
        let scaleY = options.height / originHeight;
        if (!isNumber(scaleX)) {
            scaleX = 1;
        }
        if (!isNumber(scaleY)) {
            scaleY = 1;
        }
        this._transform.scale = new Scale(scaleX, scaleY);
    },
    /**
     * @hidden
     * Sets the translation transformation based on x and y position options.
     */
    _setTranslate: function () {
        const options = this.options;
        const x = options.x || 0;
        const y = options.y || 0;
        this._transform.translate = new Translation(x, y);
    },
    /**
     * @hidden
     * Initializes the element size by setting up scaling and translation transforms.
     */
    _initSize: function () {
        const options = this.options;
        let transform = false;
        if (options.autoSize !== false && (isDefined(options.width) || isDefined(options.height))) {
            this._measure(true);
            this._setScale();
            transform = true;
        }
        if (isDefined(options.x) || isDefined(options.y)) {
            this._setTranslate();
            transform = true;
        }
        if (transform) {
            this._renderTransform();
        }
    },
    /**
     * @hidden
     * Updates the element size and position based on new options.
     * @param options - The new options to apply
     * @returns True if the element was updated, false otherwise
     */
    _updateSize: function (options) {
        let update = false;
        if (this.options.autoSize !== false && this._diffNumericOptions(options, [WIDTH, HEIGHT])) {
            update = true;
            this._measure(true);
            this._setScale();
        }
        if (this._diffNumericOptions(options, [X, Y])) {
            update = true;
            this._setTranslate();
        }
        if (update) {
            this._renderTransform();
        }
        return update;
    }
};
